import React, { PureComponent } from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import { TouchableOpacity, StyleSheet, ScrollView } from 'react-native'
import { GenericEdited, Visible, DownloadIcon, Hide, ChevronDown, ArrowRight, Info } from '@dbk/ui-icons'
import { View } from '@dbk/ui-react-utils'
import format from 'date-fns/format'
import {
  NavigationListItemHeader,
  NavigationListItemFooter,
  NavigationListItemContent,
} from '@dbk/ui-list'
import { DotIcon } from '../../../../../../src/components/common/icons'
import { Checkbox } from '@dbk/ui-forms'
import Text, { Large } from '@dbk/ui-text'
import { PALETTE } from '../../../../../../src/constants'
import PropTypes from 'prop-types'
import { formatDate } from '../report-utils'
import additionalStyles from './report-category.styles'
import { EDELIVERY_CATEGORY_ID, PDF_MIME_TYPE } from '../constants'
import envConfig  from '../../../../../../db-env-build'   
import { RM_REGION } from '../../../constants'
import { Accordion, AccordionItem } from '@dbk/ui-accordion';

const ReportCategoryListItem = props => {
  const { item } = props
  const {
    auth: { langCode, documentPreviewDisabled, documentDownloadDisabled },
    reports: { selectedCategoryId },
  } = props
  let displayId = ''
  let refCurrency = ''
  if ((item.portfolioId && item.bpId) || (item.portfolioId && !item.bpId)) {
    displayId = item.portfolioId
    refCurrency = item.refCurrency
  } else if (item.bpId && !item.portfolioId) {
    displayId = item.bpId
    refCurrency = ''
  }

  const downloadDoc = () => {
    if(documentDownloadDisabled){
      return;
    }
    props.downloadIndividualReport(item);
  }


  const receivedDate = formatDate(item.receivedDate, langCode)
  const cursorClass = documentPreviewDisabled ? 'notAllowedCursor' : 'pointerCursor'; //WMCE-42437- Switching cursor style to not allowed when preview is disabled for RM
  const categoryId = parseInt(item.categoryIds, 10);
  return (
    <View style={StyleSheet.flatten(additionalStyles.reportsTable)}>
      <View style={StyleSheet.flatten(additionalStyles.tableRootContent)}>
        <View style={StyleSheet.flatten(additionalStyles.container)}>
          <View style={StyleSheet.flatten(additionalStyles.checkbox)}>
            <Checkbox
              name="checkbox"
              checked={item.checked}
              indeterminate={item.isIndeterminate}
              className="checkboxClass"
              onClick={() => props.handleReportItemClick(item)}
              testID="checkbox_report_reportCategorylistItem_test"
            />
          </View>
          <View style={StyleSheet.flatten(additionalStyles.reportName)}>
            { documentPreviewDisabled || (item.mimeType && item.mimeType.toLowerCase() != PDF_MIME_TYPE.toLowerCase()) ?
            <View style={StyleSheet.flatten(additionalStyles.otherRow)}>
              <Large className="textStyle">{item.documentName} </Large>
              {!item.read && <div style={StyleSheet.flatten(additionalStyles.iconStyle)}><DotIcon /></div>}  
            </View>
            :
            <TouchableOpacity style={StyleSheet.flatten(additionalStyles.flexRow)} onClick={() => props.handlePreviewClick(item)}>
                <Large className="textStyle">{item.documentName} </Large>
                {!item.read && <div style={StyleSheet.flatten(additionalStyles.iconStyle)}><DotIcon /></div>}
            </TouchableOpacity> }
          </View>
          <View style={StyleSheet.flatten(additionalStyles.portfolio)}>
            <Large>
            {/* { categoryId === EDELIVERY_CATEGORY_ID.OTHER_DOCUMENTS ? '-' : (displayId ? (displayId+(refCurrency ? ' - ' + refCurrency : '')): (refCurrency ? refCurrency : '-' ))} */}
            { categoryId === EDELIVERY_CATEGORY_ID.OTHER_DOCUMENTS ? '-' : (displayId ? (displayId): (refCurrency ? refCurrency : '-' ))}
            </Large>
          </View>
          <View style={StyleSheet.flatten(additionalStyles.date)}>
            <Large testID="text_date_customTransactionHistory_test">{receivedDate}</Large>
          </View>
          <View style={StyleSheet.flatten(additionalStyles.preview)}>
          { documentPreviewDisabled || (item.mimeType && item.mimeType.toLowerCase() != PDF_MIME_TYPE.toLowerCase()) ?
              <Hide className='disable-click' width={28} height={17} color={PALETTE.primaryText}/> :
              <div className='preview-icon'>
                <Visible className='clickable' onClick={() => props.handlePreviewClick(item)} color={PALETTE.secondaryActive} />
              </div> 
          }

          </View>
          <View style={StyleSheet.flatten(additionalStyles.download)} onClick={() => downloadDoc()}>
            <DownloadIcon className={ documentDownloadDisabled ? '' : 'clickable'}
              color={ documentDownloadDisabled ? PALETTE.primaryText : PALETTE.secondaryActive}
              width={28}
              height={28}

            />
          </View>
        </View>
        { ( categoryId === EDELIVERY_CATEGORY_ID.FROM_YOUR_ADVISOR) && item.msgToClient && 
          <View className="accordion-container">
            <Accordion
              className="accordion-header"
              renderIconForClose={() => <ChevronDown className="downArrow" width={24} height={24} color={PALETTE.secondaryActive} />}
              renderIconForOpen={() => <View className="arrow-right"><ArrowRight width={24} height={24} color={PALETTE.secondaryActive} /></View>}
            >
              <AccordionItem
                className="accordion-content"
                renderTitle={
                  <View className="title-container">
                    <View className="icon-container"><Info className="acc-icon" color={PALETTE.secondaryActive} height={24} width={24}/></View>
                    <Text>{props.i18n.messages['app.chedelivery.reports.messageFromRM']}</Text>
                  </View>
                }
                itemKey={1}
                key={1}
              >
                <View>
                  <ScrollView className="max-scroll-height">
                    <Text>{item.msgToClient}</Text>
                  </ScrollView>
                </View>
              </AccordionItem>
            </Accordion>
          </View>}
      </View>
      {/* ))} */}
    </View>
  )
}

ReportCategoryListItem.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  item: PropTypes.string,
  downloadIndividualReport: PropTypes.func
}

ReportCategoryListItem.defaultProps = {
  i18n: {},
  item: {},
}

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.replace' },
      i18n: {
        messages: true,
      },
      auth: {
        langCode: true,
        documentPreviewDisabled: true,
        documentDownloadDisabled: true
      },
      reports: {
        selectedCategoryId: true,
      },
    },
  },
  ({ ui, ...queries }) => ({
    ...queries,
  })
)(ReportCategoryListItem)
